import React from 'react';

import MerchantLogo from '../../common/MerchantLogo/MerchantLogo';
import { useShipment } from '../hooks/shipment.hooks';
import EddTag from './EddTag/EddTag';
import Nickname from './Nickname/Nickname';
import SenderLocation from './SenderLocation/SenderLocation';
import { SUMMARY_PANEL_TEST_ID } from './SummaryPanel.test-ids';

import styles from './SummaryPanel.module.scss';

const SummaryPanel: React.FC = () => {
  const logoUrl = useShipment()?.merchant?.logoUrl;
  return (
    <div className={styles.summaryPanel} data-testid={SUMMARY_PANEL_TEST_ID}>
      <div className={styles.summaryRow}>
        {logoUrl && <MerchantLogo logoSrc={logoUrl} className={styles.merchantLogo} />}
        <div className={styles.nicknameSection}>
          <div>
            <Nickname />
          </div>
          <SenderLocation />
        </div>
      </div>
      <EddTag />
    </div>
  );
};

export default SummaryPanel;
